

import { atom , useRecoilValue, useSetRecoilState, useResetRecoilState} from "recoil";


const paymentMadeAtom = atom({key:'walletTransAtom', default:{transaction_type:[],wallet_transaction:[]}});



export  const SetWalletTransAtom = () => useSetRecoilState(paymentMadeAtom);
export  const GetWalletTransAtom = () => useRecoilValue(paymentMadeAtom);





